
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/check/servicing",
      function () {
        return require("private-next-pages/docs/check/servicing.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/check/servicing"])
      });
    }
  